module.exports = __webpack_public_path__ + "static/media/ico-forbidden.1153cee6.svg";